<template>
  <div class="avatarUrl">
    <img :src="userInfo.avatarUrl" alt="图片" @click="skip('/uploadAvatar')" />
    <div @click="skip('/uploadAvatar')">प्रोफ़ाइल चित्र अपलोड करें</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userInfo: null,
    };
  },
  methods: {
    skip(url) {
      this.$router.push({
        path: url,
      });
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("accountInfo"));
  },
};
</script>
<style scoped>
.avatarUrl {
  display: flex;
  flex-direction: column;
  align-items: center;
}
img {
  width: 53.125px;
  height: 53.125px;
  background: #ffffff;
  border-radius: 53.125px;
  cursor: pointer;
}
.avatarUrl > div {
  width: 60px;
  font-size: 8.75px;
  color: #2e67ea;
  margin-top: 18.75px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/mycom/avatarUrl.vue